import utils from './Utils';
import v3platform from './v3platform';
/**
 * 根据上下文获取域id
 * @param {Object} context vue实例对象
 */
function getScopeIdFromContext(context){
    return context && context && context.$root && typeof(context.$root._$getScopeId)=="function" ? context.$root._$getScopeId() : null;
}
/**
 * 错误消息处理服务
 */
var errorMsgHandlerServivce;
/**
 * 
 * @param {Object/String} message 异常消息
 */
function showError(message){
    var cb = function(sandbox){
        throw new Error(message);
    }
    if(!errorMsgHandlerServivce){
        var vjsList = ['vjs.framework.extension.platform.services.browser',"vjs.framework.extension.platform.interface.scope"];
        let promise = utils.loadVjs(vjsList);
        promise.then((sandbox)=>{
            cb();
        });
    }else{
        cb(errorMsgHandlerServivce);
    }
}

export default {

    /**
     * 重定向到指定窗体(当前页面跳转)
     */
    redirectTo(params){
        if(!params || !params.componentCode || !params.windowCode){
            throw Error("构件编码或者窗体编码为空, 无法跳转.");
        }
        this.render({
            type : "currentContainer",
            componentCode : params.componentCode,
            windowCode : params.windowCode,
            params : params.params,
            context:params.context
        })
    },
    /**
     * 保留当前页面，跳转到应用内的某个页面（模态窗体打开）
     * @param {Object} params 
     */
    navigateTo(params){

    },
    /**
     * 关闭当前页面，返回上一页面
     * @param {Object} params 
     */
    navigateBack(params){

    },

    /**
     * 获取窗体入参
     */
    getParam(params){
        var key;
        var context;
        if(typeof(params) == "object"){
            key = params.key;
            context = params.context;
        }else{
            key = params;
        }
        var value = undefined;
        var vjsList = ["vjs.framework.extension.platform.data.storage.runtime.param","vjs.framework.extension.platform.interface.scope"];
        var sandbox = undefined;
        var success = function(sBox){
            sandbox = sBox;
        }
        utils.loadVjsSync(vjsList,success);
        var windowParam = sandbox.getService("vjs.framework.extension.platform.data.storage.runtime.param.WindowParam");
        var ScopeManager = sandbox.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
        var scopeId = context && context && context.$root && typeof(context.$root._$getScopeId)=="function" ? context.$root._$getScopeId() : null;
        if(windowParam){
            value = ScopeManager.createScopeHandler({
                scopeId : scopeId,
                handler : function(wp){
                    return wp.getInput(key);
                }
            })(windowParam);
        }
        return value;
    },

    /**
     * 渲染窗体
     * @param {Object} params 
     * {
     *  componentCode : '构件编码',
     *  windowCode : '窗体编码',
     *  title : '窗体标题',
     *  context:{},
     *  params : {},//窗体输入参数
     *  type : '',//打开方式：currentContainer（当前容器跳转）currentWindow（当前浏览器跳转）newWindow（新窗体打开）
     *  success : function(){},//成功回调
     *  fail : function(){}//失败回调
     * }
     */
    render(params){
        if(!params){
            console.warn("参数无效，已忽略.");
            return;
        }
        var componentCode = params.componentCode;
        var windowCode = params.windowCode;
        var variable = params.params ? params.params :{};
        var windowInputParams = {
            "variable" : variable
        };
        var success = params.success;
        var error = params.fail;
        var title = params.title;
        var context = params.context;
        var openFunc;
        switch(params.type){
            case "currentContainer":
                windowInputParams.variable.formulaOpenMode = "locationHref";
                openFunc = function(params){
                    params.browser.redirectModule({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "params": {
                            inputParam: params.windowInputParams
                        }
                    });
                };
                break;
            case "currentWindow":
                openFunc = function(params){
                    params.browser.redirectLocation({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "title" : params.title,
                        "inputParam": params.windowInputParams
                    });
                };
                break;
            case "newWindow":
                windowInputParams.variable.formulaOpenMode = "dialog";
                openFunc = function(params){
                    params.browser.callBrowserWindow({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "title": params.title,
                        "inputParam": params.windowInputParams,
                        "isBlock": false,
                        "winName": "_blank"
                    });
                };
                break;
            default:
                throw new Error("不支持这种打开方式: " + params.type);
        }
        var vjsList = ['vjs.framework.extension.platform.services.browser',"vjs.framework.extension.platform.interface.scope"];
        let promise = utils.loadVjs(vjsList);
        var scopeId = context && context.$root && typeof(context.$root._$getScopeId)=="function" ? context.$root._$getScopeId() : null;
        promise.then((sb)=>{
            var browser = sb.getService("vjs.framework.extension.platform.services.browser.Browser");
            if(browser){
                var ScopeMananger = sb.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
                if(typeof(openFunc) == 'function'){
                    var _p = {
                        componentCode : componentCode,
                        windowCode : windowCode,
                        title : title,
                        windowInputParams : windowInputParams,
                        browser : browser
                    };
                    ScopeMananger.createScopeHandler({
                        scopeId : scopeId,
                        handler : openFunc
                    })(_p);
                    /*
                    openFunc({
                        componentCode : componentCode,
                        windowCode : windowCode,
                        title : title,
                        windowInputParams : windowInputParams,
                        browser : browser
                    });
                    */
                }
            }
        }).catch(err=>{
            error(err);
        });
    },
    /**
     * 渲染窗体到指定元素
     * @param {Object} params 
     * {
     *  componentCode : '构件编码',
     *  windowCode : '窗体编码',
     *  context:{},//vue实例对象
     *  el:Dom元素的id值或者元素对象
     *  params : {},//窗体输入参数
     *  success : function(){},//成功回调
     *  fail : function(){}//失败回调
     * }
     */
    redirectToElement(params){
        if(!params){
            return;
        }
        var componentCode = params.componentCode;
        var windowCode = params.windowCode;
        var context = params.context;
        var el = params.el;
        var fail = params.fail;
        var success = params.success;
        if(!componentCode){
            showError("构件编码不能为空, 请检查入参是否正确.");
        }
        if(!windowCode){
            showError("窗体编码不能为空, 请检查入参是否正确.");
        }
        if(!context){
            showError("vue实例不能为空, 请检查入参数据是否正确.");
        }
        var eleId;
        if(!el){
            showError("目标dom元素不存在，请检查入参数据是否正确.");
        }else if(typeof(el) == "string"){
            if(!document.getElementById(el)){
                showError("目标dom元素不存在，请检查入参数据是否正确.");
            }else{
                eleId = el;
            }   
        }else{
            if(el[0]){
                el = el[0];
            }
            eleId = el.getAttribute("id");
            if(!eleId){
                eleId = "rootContainer_" + (new Date).getTime();
                el.setAttribute("id",eleId);
            }
        }
        var _inputParams = {
            variable : params.params
        };
        var parentScopeId = getScopeIdFromContext(context);
        var vjsList = ['vjs.framework.extension.ui.adapter.dependency','vjs.framework.extension.platform.services.view.relation','vjs.framework.extension.platform.services.view.widget.common.action',"vjs.framework.extension.platform.interface.scope","vjs.framework.extension.platform.data.storage.schema.param"];
        let promise = utils.loadVjs(vjsList);
        promise.then((sb)=>{
            var AppData = sb.getService("vjs.framework.extension.platform.data.storage.schema.param.ApplicationParam");
            if(AppData && typeof(AppData.getWindowMapping) == 'function'){
                /* 获取窗体映射信息 */
                var windowMappingInfo = AppData.getWindowMapping({
                    componentCode : componentCode,
                    windowCode : windowCode,
                });
                /* 若窗体映射信息不为空的话，则表示是配置相应的映射信息，需替换 */
                if(windowMappingInfo!=null){
                    componentCode = windowMappingInfo.componentCode;
                    windowCode = windowMappingInfo.windowCode;
                }
            }
            var WindowContainer = sb.getService("vjs.framework.extension.platform.services.view.relation.WindowContainer");
            var windowRelation = sb.getService("vjs.framework.extension.platform.services.view.relation.WindowContainerManager");
            var widgetRenderer = sb.getService("vjs.framework.extension.platform.services.view.widget.common.action.WidgetRenderer");
            var ScopeManager = sb.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
            var newScopeId = ScopeManager.createWindowScope({
                "parentScopeId": parentScopeId,
                "componentCode": componentCode,
                "windowCode": windowCode
            });
            var windowScope = ScopeManager.getScope(newScopeId);
            //先沿用vui标签的打开方式，目前关闭方式只在浙交工使用，还没集成到主线版本
            windowScope.setOpenMode("vuiWindowContainer");
            var container = new WindowContainer({
                scopeId: newScopeId,
                componentCode: componentCode,
                windowCode: windowCode,
                windowType: "ComponentContainer"
            });
            windowRelation.put(container);
            var callback = function(){
                var renderCallback = function(_winContent){
                    var _winScope = ScopeManager.getWindowScope();
                    var tmpScript = _winContent[0];
                    var tmpContent = _winContent[1];
                    var isSimple = false;
                    var tmpId;
                    if(_winScope.getSeries() == "bootstrap_mobile"){
                        isSimple = true;
                        if(!_winScope.isSimpleDivWindow()){//简约div
                            var widgets = _winScope.getWidgets();
                            if(widgets){
                                for(var widgetCode in widgets){
                                    var type = widgets[widgetCode].type;
                                    if(type !="JGComponent" && type !="JGMDiv"){
                                        isSimple = false;
                                        break;
                                    }
                                }
                            }else{
                                isSimple = false;
                            }
                        }
                        if(isSimple){
                            var tmpDiv = document.createElement("div");
                            var cDiv = document.createElement("div");
                            tmpDiv.appendChild(cDiv);
                            tmpId = "ap_" + (new Date()).getTime();
                            tmpDiv.setAttribute("id", tmpId);
                            document.getElementById(eleId).appendChild(tmpDiv);
                            _winScope.set("AssignRenderPlace",{//指定渲染位置，场景：渲染移动窗体到div需要自适应高
                                dom : cDiv
                            });
                        }else{
                            _winContent = $("<script type=\"text/javascript\">"+tmpScript.innerHTML+"</script>" + tmpContent.innerHTML);
                        }
                    }
                    widgetRenderer.executeComponentRenderAction("renderWindowToContainer", _winContent, eleId, false);
                    widgetRenderer.executeComponentRenderAction("setParentContainerInfo", windowCode, {
                        scopeId:parentScopeId,
                        containerCode:eleId
                    });
                    if(isSimple){
                        document.getElementById(eleId).removeChild(tmpContent);
                    }
                    windowScope.on(ScopeManager.EVENTS.DESTROY,(function(_eleId, _content, _tmpId){
                        return function(){
                            var ctDom = document.getElementById(_eleId);
                            try{
                                if(_tmpId){
                                    ctDom.removeChild(document.getElementById(_tmpId));
                                }
                                if(_content && _content.length > 0){
                                    for(var i = 0,len = _content.length;i<len;i++){
                                        ctDom.removeChild(_content[i]);
                                    }
                                }
                            }catch(e){ }
                            //document.getElementById(eleId).innerHTML = "";
                        }
                    })(eleId,_winContent,tmpId))
                    windowScope.set("RemoveModalFunc",(function(_eleId, _content, _tmpId){
                        return function(){
                            var ctDom = document.getElementById(_eleId);
                            try{
                                if(_tmpId){
                                    ctDom.removeChild(document.getElementById(_tmpId));
                                }
                                if(_content && _content.length > 0){
                                    for(var i = 0,len = _content.length;i<len;i++){
                                        ctDom.removeChild(_content[i]);
                                    }
                                }
                            }catch(e){ }
                            //document.getElementById(eleId).innerHTML = "";
                        }
                    })(eleId, _winContent, tmpId));
                }
                var componentUtil = sb.getService("vjs.framework.extension.ui.adapter.init." + ScopeManager.getProperty("type") + ".web.util");
        		componentUtil.renderComponentById(componentCode, windowCode, _inputParams || {}, {
        			"scopeId": newScopeId,
        			"rendered": renderCallback,
                    "inited": success,
        			"error": fail
        		})
            }
            var dependency = sb.getService("vjs.framework.extension.ui.adapter.dependency");
            dependency.loadResources(componentCode, windowCode, sb, newScopeId, callback, fail)
        });
    },

    /**
     * 渲染窗体到首页页面
     * {
     *      type: "homeTab",//打开方式可选值：1、homeTab（首页，默认值），2、modal（模态）
     *      menuCode: "菜单编码",
     *      scope: "current",//可选值：1、current（当前，默认值），2、parent（父级），type为homeTab时有效，若后续支持top需要考虑首页怎么给当前窗体回复消息（三层嵌套，中间层非首页）
     *      error:  function(msg){}//打开失败回调
     * }
    */
    renderFromPortalMenu : function(params){
        var type = params.type ? params.type : "homeTab",
            menuCode = params.menuCode,
            error = params.error,
            scope = params.scope ? params.scope : "current";
        var isError = false;
        var errorMsg = "";
        if(type != "homeTab" && type != "modal"){
            errorMsg = "打开方式仅支持首页或者模态弹窗，当前打开方式：" + msg;
        }else if(!menuCode){
            errorMsg = "菜单编码不能为空";
        }else if(scope != "current" && scope != "parent"){
            errorMsg = "作用域错误，仅支持当前首页或者父级首页，当前作用域：" + scope;
        }
        if(isError){
            v3platform.v3ExceptionAlert({
                "title" : "业务异常",
                "msgHeader" : "参数传递错误",
                "msg" : errorMsg,
                "callback":error
            });
            return;
        }
        var vjsList;
        var loadSuccess;
        switch(scope){
            case "parent"://父级打开
                vjsList = ['vjs.framework.extension.platform.interface.event'];
                loadSuccess = (sb)=>{
                    var eventManager = sb.getService("vjs.framework.extension.platform.interface.event.EventManager");
                    //当前通信id
                    var iden = v3platform.genUUID();
                    var sendState = false;//发送状态
                    eventManager.onCrossDomainEvent({//接受返回的首页消息
                        eventName: eventManager.CrossDomainEvents.CustomEvent,
                        eventInfo : {
                            condition:"type=='HomeTabMessageCallback'&&iden=='"+iden+"'"
                        },
                        handler: function(resParams){
                            if(!resParams){
                                return;
                            }
                            var responType = resParams.type;
                            switch(responType){
                                case "parentReceived":
                                    sendState = true;
                                    break;
                            }
                        }
                    });
                    eventManager.fireCrossDomainEvent({//给父级发送打开消息
                        eventName: eventManager.CrossDomainEvents.CustomEvent,
                        eventInfo : {
                            type : "OpenHomeTabMenuByCode"
                        },
                        params: {
                            iden : iden,
                            openParams : {
                                type : type,
                                menuCode : menuCode,
                                scope : "current"
                            }
                        }
                    });
                    setTimeout(function(){
                        if(!sendState){//3秒后还收不到返回消息，就提示报错
                            v3platform.v3ExceptionAlert({
                                "title" : "系统异常",
                                "msgHeader" : "无法打开窗体",
                                "msg" : "请检查当前窗体属于首页的子窗体, scope:" + scope,
                                "callback":error
                            });
                            return;
                        }
                    },3000);
                }
                break;
            default://当前
                switch(type){
                    case "modal":
                        if(window.V3PlatformHomeTab && typeof(window.V3PlatformHomeTab.getMenuData) == "function"){
                            var menuItem = window.V3PlatformHomeTab.getMenuData(menuCode);
                            if(!menuItem){
                                v3platform.v3ExceptionAlert({
                                    "title" : "业务异常",
                                    "msgHeader" : "参数传递错误",
                                    "msg" : "菜单编码错误，无法获取对应菜单数据，菜单编码：" + menuCode,
                                    "callback":error
                                });
                                return;
                            }
                            var title = menuItem.menuItemName;
                            if(menuItem.menuItemType == "url"){
                                vjsList = ["vjs.framework.extension.platform.services.view.modal"];
                                if(!menuItem.url){
                                    v3platform.v3Log("warn", "菜单编码无映射链接，已忽略打开，菜单编码：" + menuCode);
                                }
                                loadSuccess = (sb)=>{
                                    var modalUtils = sb.getService("vjs.framework.extension.platform.services.view.modal.CreateModalByUrl");
                                    modalUtils.create({
                                        "url": menuItem.url,
                                        "title": title
                                    });
                                }
                            }else if(menuItem.menuItemType == "win"){
                                var componentCode = menuItem.openCompCode;
                                var windowCode = menuItem.openWinCode;
                                if(!componentCode || !windowCode){
                                    /*v3platform.v3ExceptionAlert({
                                        "title" : "系统异常",
                                        "msgHeader" : "无法打开窗体",
                                        "msg" : "菜单编码无映射窗体，菜单编码：" + menuCode,
                                        "callback":error
                                    });*/
                                    v3platform.v3Log("warn", "菜单编码无映射窗体，已忽略打开，菜单编码：" + menuCode);
                                    return;
                                }
                                vjsList = ["vjs.framework.extension.platform.services.browser"];
                                loadSuccess = (sb)=>{
                                    var browser = sb.getService("vjs.framework.extension.platform.services.browser.Browser");
                                    var windowInputParams = {
                                        "variable": {
                                            "formulaOpenMode" : "dialog"
                                        }
                                    };
                                    browser.showModalModule({
                                        "componentCode": componentCode,
                                        "windowCode": windowCode,
                                        "title": title,
                                        "inputParam": windowInputParams
                                    });
                                }
                            }
                        }else{
                            v3platform.v3ExceptionAlert({
                                "title" : "系统异常",
                                "msgHeader" : "无法打开窗体",
                                "msg" : "未获取到首页提供的接口：getMenuData",
                                "callback":error
                            });
                            return;
                        }
                        break;
                    default:
                        if(window.V3PlatformHomeTab && typeof(window.V3PlatformHomeTab.openMenu) == "function"){
                            window.V3PlatformHomeTab.openMenu({
                                menuCode : menuCode,
                                error : error
                            });
                        }else{
                            v3platform.v3ExceptionAlert({
                                "title" : "系统异常",
                                "msgHeader" : "无法打开窗体",
                                "msg" : "未获取到首页提供的接口：openMenu",
                                "callback":error
                            });
                        }
                        return;
                }
        }
        let promise = utils.loadVjs(vjsList);
        promise.then(loadSuccess).catch((msg)=>{
            v3platform.v3ExceptionAlert({
                "title" : "系统异常",
                "msgHeader" : "无法打开窗体",
                "msg" : "加载相关的vjs服务失败：" + msg,
                "callback":error
            })
        })
    }

};


// WEBPACK FOOTER //
// ./src/Window.js